<template>
<div>
    <div class="table-pagination">
        <Pagination
            :max="maxPage"
            :value="currentPage"
            :pageSize="currentPageSize"
            @input="updateCurrentPage"
            show-per-page
            @inputPageSize="updatePageSize"
        />
    </div>

    <div class="table-wrap">
        <ExpertPanelTable
            :columns="columns"
            :rows="rows"
            @click="select"
            :filter="inputFilter"
            @updateFilter="updateFilter"
        />
    </div>
</div>
</template>

<script>
import Pagination from "@/components/UI/Pagination.vue";
import ExpertPanelTable from "@/components/expert-panel-new/tables/ExpertPanelTable.vue";
import {rusDateTime} from "@/tools/date_format";
import FilterInput from "@/components/expert-panel-new/tables/filters/FilterInput.vue";

export default {
    name: "ExpertPanelTableChecking",
    components: {ExpertPanelTable, Pagination},
    props: {
        rows: Array,
        review: Object,
        currentPage: Number,
        currentPageSize: Number,
        total: Number,
        filter: Object,
    },
    computed: {
        maxPage() {
            return this.$store.getters['examination/pagesCount'](this.total, this.currentPageSize);
        },
        columns() {
            return [
                {
                    id: 'id',
                    name: 'ID работы',
                    value: (row) => row.id,
                    visible: true,
                    filter: {
                        type: FilterInput,
                        params: {
                            alias: 'id',
                            name: 'ID работы',
                        },
                    },
                },
                {
                    id: 'userId',
                    name: 'ID участника',
                    value: (row) => row.userId,
                    visible: !(this.review && this.review.isAnonymous),
                    filter: {
                        type: FilterInput,
                        params: {
                            alias: 'userId',
                            name: 'ID участника',
                        },
                    },
                },
                {
                    id: 'fio',
                    name: 'ФИО участника',
                    value: (row) => row.fio,
                    visible: !(this.review && this.review.isAnonymous),
                },
                {
                    id: 'phone',
                    name: 'Телефон',
                    value: (row) => row.phone,
                    visible: !(this.review && this.review.isAnonymous),
                },
                {
                    id: 'date',
                    name: 'Дата решения',
                    value: (row) => rusDateTime(row.readyForReviewAt),
                    visible: true,
                },
            ].filter((column) => column.visible);
        },
    },
    data() {
        return {
            inputFilter: {...this.filter},
        };
    },
    watch: {
        filter() {
            this.inputFilter = {...this.filter};
        },
    },
    methods: {
        select(activitySession) {
            if (this.review.activityType === 'task') {
                this.$router.push(`/expert-panel/review/${this.$route.params.event}/${activitySession.id}${activitySession.status === 'in_headexpert_check' ? '/super' : ''}`);
            } else {
                this.$router.push(`/expert-panel/old/review/${this.$route.params.event}/${activitySession.id}`);
            }
        },
        updateCurrentPage(newPage) {
            this.$emit('update-current-page', newPage);
        },
        updatePageSize(newPageSize) {
            this.$emit('update-page-size', newPageSize);
        },
        updateFilter(filter) {
            this.$emit('update-filter', filter);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.table {
  &-wrap {
    margin-top: rem(16);
  }
  &-pagination {
    text-align: right;
  }
}
</style>